export const DOWNLOADS_URL = '/downloads/offline/';
export const MEGABYTE = 1024 * 1024;
export const PLATFORMS = [
  { key: 'macos', name: 'macOS', hint: 'macOS first launch hint' },
  { key: 'linux', name: 'Linux', hint: 'Linux first launch hint' },
  { key: 'windows', name: 'Windows', hint: 'Windows first launch hint' },
];
const PLATFORM_PATTERNS = [
  { key: 'windows', pattern: /Win/ },
  { key: 'macos', pattern: /Mac/ },
  { key: 'linux', pattern: /Linux/ },
];

// Whether the email belongs to an AZmed staff member
export const isAzmedUser = email =>
  typeof email === 'string' && email.toLowerCase().endsWith('@azmed.co');

// Manifest key of the current OS, null when it cannot be told
export const detectPlatform = () => {
  const { userAgentData, userAgent } = navigator;
  const source = (userAgentData && userAgentData.platform) || userAgent;
  const match = PLATFORM_PATTERNS.find(({ pattern }) => pattern.test(source));

  return match ? match.key : null;
};

// Artifact of the platform in the manifest, null when there is none
export const pickArtifact = ({ manifest, downloadsUrl }, platform) => {
  const artifact = manifest && platform && manifest.artifacts[platform];
  if (!artifact) {
    return null;
  }

  const { file } = artifact;

  return { url: `${downloadsUrl}${file}`, file };
};

// Production data URL of the manifest, null unless it is a valid https URL
export const pickDataUrl = manifest => {
  const dataUrl = manifest && manifest.dataUrl;
  if (typeof dataUrl !== 'string') {
    return null;
  }

  try {
    return new URL(dataUrl).protocol === 'https:' ? dataUrl : null;
  } catch {
    return null;
  }
};

// Start a same-origin download of the file through a temporary link
export const downloadFile = (url, file) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = file;

  document.body.appendChild(link);
  link.click();
  link.remove();
};
